import { render, staticRenderFns } from "./currencyList.vue?vue&type=template&id=5fb9c5ff&scoped=true&"
import script from "./currencyList.vue?vue&type=script&lang=js&"
export * from "./currencyList.vue?vue&type=script&lang=js&"
import style0 from "./currencyList.vue?vue&type=style&index=0&id=5fb9c5ff&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb9c5ff",
  null
  
)

export default component.exports